import MuiList from '@mui/material/List';
import { styled } from '@mui/material/styles';

export const StyledMuiList = styled(MuiList, {
  shouldForwardProp: prop => prop !== 'listHeight' && prop !== 'hasError',
})<{
  component: string;
  listHeight: number;
  hasError: boolean;
}>`
  /* 2px for top and bottom border */
  height: ${({ listHeight }) => listHeight + 2}px;
  border: 1px solid ${({ theme, hasError }) => (hasError ? theme.palette.error.main : theme.palette.divider)};
  background-color: ${({ theme, hasError }) => (hasError ? theme.palette.error.light : theme.palette.background.paper)};
`;
